export default "__VITE_ASSET__BPjjI$wR__"